<template>
  <vame @update="update">
    <renderer
      :scale="3"
      :pixel-scale="6"
      :clear-color="'#fff'"
      :use-ecs="true"
      :ecs-render-components="renderComponents"
    >
    </renderer>
  </vame>
</template>

<script>
import { mapState } from 'vuex'
import { components, store } from '@/vame.js'
import VueLogo from './VueLogo.vue'
import VueLogoComponent from './VueLogo.js'

const { createStore, createEntity } = store
const { Render: RenderComponent } = store.components

export default {
  store: createStore(),

  components: {
    ...components
  },

  data () {
    return {
      entityUid: undefined
    }
  },

  computed: {
    ...mapState({
      entities: 'entities',
      components: 'components'
    }),

    renderComponents () {
      return {
        VueLogo
      }
    }
  },

  created () {
    this.$store.dispatch('resetState')
    this.createLogo()
  },

  methods: {
    createLogo () {
      const { dispatch, getters } = this.$store

      dispatch('addEntity', createEntity('vue-logo'))
      const entityUid = getters.lastEntityUid
      this.entityUid = entityUid

      let component = RenderComponent.create({ vueComponent: 'VueLogo' })
      dispatch('addComponent', { entityUid, component })

      component = VueLogoComponent.create({
        x: 160-16,
        y: 90-16,
        width: 32,
        height: 32
      })
      dispatch('addComponent', { entityUid, component })
    },

    update () {
      const { entityUid } = this
      const components = this.components[entityUid]
      const component  = components.find((c) => c.kind === 'vue-logo')

      component.x = (Math.cos(performance.now()/1000) * 50) + (160-16)
      component.y = (Math.sin(performance.now()/1000) * 50) + (90-16)

      this.$store.dispatch('setComponent', { entityUid, component })
    }
  }
}
</script>

<style lang="sass">
body
  background: #fafafa
</style>
